import { Vue3Marquee } from 'vue3-marquee';
import 'vue3-marquee/dist/style.css';
import { mapMutations, mapState } from 'vuex';
import { getSongComment } from '@/request/api/item.js';
import SongComment from '@/components/MusicListItem/SongComment.vue';
export default {
  name: 'MusicDetails',
  props: ['musicList', 'play', 'isbtnShow', 'addDuration'],

  data() {
    return {
      lyricIsShow: false,
      //歌词是否显示
      isPopups: false,
      //评论弹出层是否显示
      songComment: null
    };
  },

  computed: { ...mapState(["lyricList", "currentTime", "playListIndex", "playList", "duration"]),
    lyric: function () {
      let arr = [];

      if (this.lyricList.lyric) {
        arr = this.lyricList.lyric.split(/[(\r\n)\r\n]+/).map(item => {
          let min = item.slice(1, 3);
          let sec = item.slice(4, 6);
          let mill = item.slice(7, 10);
          let lrc = item.slice(11, item.length);
          let time = parseInt(min) * 60 * 1000 + parseInt(sec) * 1000 + parseInt(mill);

          if (isNaN(Number(mill))) {
            mill = item.slice(7, 9);
            lrc = item.slice(10, item.length);
            time = parseInt(min) * 60 * 1000 + parseInt(sec) * 1000 + parseInt(mill);
          }

          return {
            min,
            sec,
            mill,
            lrc,
            time
          };
        });
        arr.forEach((item, i) => {
          if (i === arr.length - 1 || isNaN(arr[i + 1].time)) {
            item.pretime = 10000000;
          } else {
            item.pretime = arr[i + 1].time;
          }
        });
      } // console.log(arr);


      return arr;
    }
  },
  components: {
    Vue3Marquee,
    SongComment
  },

  mounted() {
    console.log(this.playList);
    this.addDuration();
    this.getSongComment();
  },

  methods: {
    //播放
    toplay(value) {
      let index = this.playListIndex + value; // console.log(this.playList);

      if (index < 0) {
        index = this.playList.length - 1;
      } else if (index == this.playList.length) {
        index = 0;
      }

      this.updateplayListIndex(index);
    },

    //获取歌曲评论
    getSongComment: async function () {
      let data = await getSongComment(this.playList[0].id);
      this.songComment = data; // console.log(data);
    },
    ...mapMutations(['updateIsPopups', 'updateplayListIndex'])
  },
  watch: {
    currentTime(newValue) {
      if (document.querySelector('p.p_active')) {
        let top = document.querySelector('p.p_active').offsetTop;

        if (top >= 242) {
          this.$refs.musicLyric.scrollTop = top - 242;
        }
      }

      if (newValue == this.duration) {
        this.toplay(1);
      } // console.log((parseInt(this.currentTime) / parseInt(this.duration)) * 100);

    }

  }
};